export default __webpack_public_path__ + "static/yes-549ffac21b675c61a743e57f21179481.jpg";